module.exports = __webpack_public_path__ + "static/img/bg_home.8626970.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/simple/bg_home.png
// module id = EnP/
// module chunks = 3